import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useProductCounter} from 'hooks/product/useProductCounter';
import {ProductCounterSticky} from 'modules/product-card/components/ProductCounterSticky';
import {FC} from 'react';

export const ProductBuyStickyCartCounter: FC = () => {
    const productData = useAppSelector(selectProductData);
    const productStock = productData?.stockAmount ?? 0;
    const {count, handleChange, handleDecrement, handleIncrement} = useProductCounter(productStock);

    return (
        <div>
            <ProductCounterSticky
                count={count}
                onChange={handleChange}
                onDecrement={handleDecrement}
                onIncrement={handleIncrement}
                disabledIncrement={Boolean(productStock) && count !== undefined && count >= productStock}
            />
        </div>
    );
};
